const STATUS_STYLES = {
  pending:   "bg-slate-100 text-slate-700",
  partial:   "bg-amber-100 text-amber-800",
  paid:      "bg-emerald-100 text-emerald-800",
  cancelled: "bg-red-100 text-red-800",
};
const STATUS_LABELS = {
  pending: "Pendiente",
  partial: "Parcial",
  paid: "Pagada",
  cancelled: "Cancelada",
};

const AGING_STYLES = {
  "0-30":  "bg-emerald-50 text-emerald-700",
  "31-60": "bg-amber-50 text-amber-700",
  "61-90": "bg-orange-100 text-orange-800",
  "90+":   "bg-red-100 text-red-800",
};

export function ApStatusBadge({ status }) {
  const cls = STATUS_STYLES[status] || STATUS_STYLES.pending;
  return (
    <span className={`inline-flex items-center rounded-full px-2 py-0.5 text-[11px] font-medium ${cls}`}>
      {STATUS_LABELS[status] || status}
    </span>
  );
}

export function AgingBadge({ bucket, days }) {
  const cls = AGING_STYLES[bucket] || AGING_STYLES["0-30"];
  return (
    <span className={`inline-flex items-center rounded-full px-2 py-0.5 text-[10px] font-medium ${cls}`}>
      {bucket} <span className="opacity-70 ml-1">({days || 0}d)</span>
    </span>
  );
}
